import { adsConfig } from '@shared/ads-config.mjs';

/**
 * AdRail — coluna lateral direita com até 3 cards de anúncio (apenas desktop).
 * Só renderiza se adsConfig.enabled === true e houver IDs de blocos válidos.
 * Nunca interrompe o áudio e não usa placeholders.
 */
export function initAdRail() {
  const rail = document.getElementById('ad-rail');
  if (!rail || !adsConfig.enabled) return;

  const slots = adsConfig.slots.filter(Boolean);
  if (slots.length === 0) return;

  rail.innerHTML = slots
    .map(
      (slot) => `
      <div class="ad-card">
        <span class="ad-card-label">Publicidade</span>
        <ins class="adsbygoogle"
             style="display:block"
             data-ad-client="${adsConfig.client}"
             data-ad-slot="${slot}"
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>
      </div>`
    )
    .join('');
  rail.hidden = false;

  slots.forEach(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.warn('AdSense indisponível:', e);
    }
  });
}
